import { render, staticRenderFns } from "./MentionedAssets.vue?vue&type=template&id=1bc078b0&scoped=true&"
import script from "./MentionedAssets.vue?vue&type=script&lang=js&"
export * from "./MentionedAssets.vue?vue&type=script&lang=js&"
import style0 from "./MentionedAssets.vue?vue&type=style&index=0&id=1bc078b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc078b0",
  null
  
)

export default component.exports